const role = () => {
    $(document).ready(function () {
        const rocks = $('.rocks > div');

        $('.role__content .role__category').on('mouseenter', function () {
            const index = $(this).parent().index();
            
            $('.rocks > div.active').removeClass('active');
            rocks.eq(index).addClass('active');
            
            $('.role__rocks .role__category').eq(index).addClass('active');
            $('.rocks').addClass('active');
        });

        $('.role__content .role__category').on('mouseleave', function () {
            const activeRock = $('.rocks > div.active');

            activeRock.removeClass('active').addClass('leave-active');

            setTimeout(() => {
                activeRock.removeClass('leave-active');
            }, 300); 

            $('.rocks.active').removeClass('active');
            $('.role__rocks .role__category.active').removeClass('active');
        });
    });
};

export default role;
